package com.neurobs.ccabserver.translation.util

import com.neurobs.ccab.db.{LanguageData, PhraseGroupData, TranslationData, TranslationEngineData}
import com.neurobs.ccab.translation.{OrderedTranslationPhraseData}
import com.neurobs.util.SecondsTimestamp
import org.scalajs.dom.console

class PhraseGroupManager(val phraseGroup: PhraseGroupData, val translationEngines: List[TranslationEngineData]) {

  def phraseGroupId = phraseGroup.id
  def phraseGroupIdentifier = phraseGroup.identifier
  def phraseGroupDisplayName = phraseGroup.displayName

  var phraseManagers: Option[Map[Long, PhraseTranslationManager]] = None
  def phrases = phraseManagers.map(_.map(_._2.phrase).toList)

  def phrasesLoaded = phraseManagers.isDefined

  def setPhrases(phrases: List[OrderedTranslationPhraseData]) = {
    phraseManagers = Some(
      phrases.map(phrase => phrase.id -> new PhraseTranslationManager(phrase, translationEngines)).toMap
    )
  }

  def needsTranslation = phraseManagers.map(_.exists(!_._2.isTranslated))

  def findPhraseManagerById(phraseId: Long) = phraseManagers.flatMap(_.find(_._2.phraseId == phraseId).map(_._2))
  def markTranslatedPhrase(phraseId: Long) = findPhraseManagerById(phraseId).map(phraseManager => {
    phraseManager.markAsTranslated()
  })
}

object PhraseGroupManager {
  def apply() = new PhraseGroupManager(
    phraseGroup = PhraseGroupData(-1, SecondsTimestamp.now(), "", "", ""),
    translationEngines = List()
  )
}

class PhraseTranslationManager(val phrase: OrderedTranslationPhraseData, val translationEngines: List[TranslationEngineData]) {

  var isTranslated = phrase.translationId.isDefined
  def markAsTranslated() = {
    isTranslated = true
  }

  def phraseId = phrase.id
  def phraseIndex = phrase.index

  var userTranslation: Option[TranslationData] = None
  val engineTranslations: Map[String, PhraseTranslationCache] = translationEngines.map(engine => engine.identifier -> new PhraseTranslationCache(engine, phrase)).toMap
}

object PhraseTranslationManager {
  implicit def ordering[A <: PhraseTranslationManager]: Ordering[A] = Ordering.by(_.phraseIndex)

  def apply() = new PhraseTranslationManager(
    phrase = OrderedTranslationPhraseData.empty(),
    translationEngines = List(),
  )
}


class PhraseTranslationCache(val translationEngine: TranslationEngineData, val phrase: OrderedTranslationPhraseData) {

  var existingTranslation: Option[TranslationData] = None

  def setTranslation(translation: TranslationData) = {
    existingTranslation = Some(translation)
  }

}

object EnginePhraseTranslation {
  def apply() = new PhraseTranslationCache(TranslationEngineData(-1, SecondsTimestamp.now(), "", "", None), OrderedTranslationPhraseData.empty())
}